import MessageForm from "./MessageForm";

function App() {
  return (
    <div className="App">
      <MessageForm />
    </div>
  );
}

export default App;
